
      
   <template>
      <div>
         <div class="main_home">
    <!-- main div -->
    <div class="about_main">
        <!-- image div -->
        <div class="about_img" v-if="data.image">
            <img :src="data.image">
        </div>
        <!-- HTML EDITOR div -->
        <div class="about_box">
            <div class="ui violet segment about_text" v-html="parseHtml(data.text)"></div>
        </div>
    </div>
</div>
      </div>
   </template>
   
   <script>
      
      export default {
  props: {
    context: Object,
  },
  data() {
    return {
      configValue: undefined,
      data: {},
    };
  },
  async created() {
    this.data = await getStaticPageInfo('about_us');
  },
  methods: {
    parseHtml(html){
      return sanitizeHtml(html)
    },
  },
  components: {},
};
   </script>

   <style scoped>
      .main_home {
  padding: 2% 4% 4%;
}
.main_home .about_main {
  text-align: justify;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100% !important;
  align-content: center;
  padding: 0px 8%;
  border-radius: 12px;
}
.main_home .about_main .about_img {
  display: flex;
}
.main_home .about_main .about_img img {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
  max-height: 300px;
}
.main_home .about_main .about_box {
  width: 90%;
  margin-block-start: 5%;
}
.main_home .about_main .about_box .about_text {
  border-radius: 12px !important;
  padding: 5%;
}

@media only screen and (min-width: 600px) and (max-width: 950px) {
  .about_main {
    padding: 3% !important;
  }
}
@media only screen and (min-width: 450px) and (max-width: 600px) {
  .main_home {
    padding: 1% !important;
  }
  .main_home .about_main {
    padding: 1.5% !important;
  }
  .main_home .about_main img {
    width: 250px !important;
    height: 150px !important;
  }
  .main_home .about_main .about_text {
    width: 100% !important;
  }
}
@media only screen and (max-width: 450px) {
  .main_home {
    padding: 0.5% !important;
  }
  .main_home .about_main {
    padding: 1% !important;
    padding-top: 2% !important;
  }
  .main_home .about_main .about_img {
    width: 250px !important;
  }
  .main_home .about_main .about_img img {
    width: 250px !important;
    height: 150px !important;
  }
  .main_home .about_main .about_text {
    width: 100% !important;
  }
}

   </style>
    
  
   